import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  Button,
  Grid,
  Box,
  FormControlLabel,
  Card,
  CardContent,
} from "@mui/material";

function RoleCatAssign() {
  const [roles, setRoles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Fetch roles and categories on component mount
  useEffect(() => {
        
    axios.get(`${API_BASE_URL}/api/getRoles`).then((response) => {
      setRoles(response.data);
    });
    axios.get(`${API_BASE_URL}/api/getCatecory`).then((response) => {
      setCategories(response.data);
    });
  }, []);

  // Handle category and subcategory selection
  const handleCategoryChange = (categoryId, isSubcategory = false) => {
    if (isSubcategory) {
      setSelectedCategories((prev) =>
        prev.includes(categoryId)
          ? prev.filter((id) => id !== categoryId)
          : [...prev, categoryId]
      );
    } else {
      // Toggling the parent category
      const relatedSubcategories = categories
        .find((cat) => cat.id === categoryId)
        ?.subcategories.map((sub) => sub.id) || [];
  
      const isCategoryChecked = selectedCategories.includes(categoryId);
  
      setSelectedCategories((prev) => {
        if (isCategoryChecked) {
          // Remove category and all its subcategories
          return prev.filter(
            (id) => id !== categoryId && !relatedSubcategories.includes(id)
          );
        } else {
          // Add category and all its subcategories
          return [...prev, categoryId, ...relatedSubcategories];
        }
      });
    }
  };
  
  const handleSubmit = () => {
   
    if (!selectedRole) {
      alert("Please select a role.");
      return;
    }

    const categoriesArray = [selectedCategories];

    axios
      .post(`${API_BASE_URL}/api/assignCategoriesToRole`, {
        role_id: selectedRole,
        categories: categoriesArray,
      })
      .then((response) => {
        alert("Categories assigned successfully!");
      })
      .catch((error) => {
        console.error(error);
        alert("Failed to assign categories.");
      });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Card>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Assign Categories to Roles
          </Typography>
          <FormControl fullWidth margin="normal">
            <InputLabel>Select Role</InputLabel>
            <Select
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
            >
              <MenuItem value="">
                <em>Select Role</em>
              </MenuItem>
              {roles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Typography variant="h6" sx={{ mt: 3 }}>
            Categories
          </Typography>
          <Box sx={{ maxHeight: 300, overflowY: "auto", mt: 1 }}>
            {categories.map((category) => (
              <Box key={category.id}>
                
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedCategories.includes(category.id)}
                      onChange={() => handleCategoryChange(category.id, false)}
                    />
                  }
                  label={category.name}
                />
                {category.subcategories &&
                  category.subcategories.map((subcategory) => (
                    <Box key={subcategory.id} sx={{ pl: 4 }}>
                      
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedCategories.includes(subcategory.id)}
                            onChange={() => handleCategoryChange(subcategory.id, true)}
                          />
                        }
                        label={subcategory.name}
                      />
                    </Box>
                  ))}
              </Box>
            ))}
          </Box>


          {/* Submit Button */}
          <Grid container justifyContent="center" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              Assign Categories
            </Button>
          </Grid>
        </CardContent>
      </Card>
    </Container>
  );
}

export default RoleCatAssign;
